import React from 'react'
import Sidebar from './leftSidebar'
import Topbar from './topBar'
import { Outlet } from 'react-router-dom'

const AdminLayout = () => {
    return (
        <div>
            <div className="flex bg-[#f9f9f9] min-h-[100vh]">
                <Sidebar />
                <div className="md:ml-64 w-full mt-20 ">
                    <Topbar />
                    <Outlet />
                </div>
            </div>
        </div>
    ) 
}

export default AdminLayout
